var Cookies = require('js-cookie');
$(document).ready(function () {
  if (checkIfExists('.checkout')) {
    $('.checkout .right-col').fadeIn();
    $('.checkout .left-col').css('opacity', '1');

    $('#checkout-form').validate({
      ignore: '.ignore',
      rules: {
        email: {
          required: true,
          email: true
        },
        shipping_to: true
      },
      messages: {
        email: {
          required: $('#checkout-form input[type=email]').data('msg'),
          email: $('#checkout-form input[type=email]').data('email')
        },
        required: $('#checkout-form select[name=shipping_to]').data('msg'),
      },
      errorPlacement: function(error, element) {
        var placement = $(element).data('error');
        if (placement) {
          $(placement).append(error)
        } else {
          error.insertAfter(element);
        }
      }
    });

    var country = $('#checkout-form').data('language');
    var csrf = $('#checkout-form input[name=_token]').val();

    $('#city').on('keyup', function(){
      $('#city_id').val('');
    });

    $('#address').on('keyup', function(){
      $('#address_id').val('');
    });



    if (checkIfExists('.checkout input[name=courier]')) {
      $('input[name=courier]').on('change', function(){

        if($('.checkout input[name=courier]:checked').val() == 1) {
          $('label[for="courier_speedy"]').addClass('active');
          $('label[for="courier_econt"]').removeClass('active');
          $('label[for="courier_euroshipment"]').removeClass('active');
        }else if($('.checkout input[name=courier]:checked').val() == 5){
          $('label[for="courier_speedy"]').removeClass('active');
          $('label[for="courier_econt"]').removeClass('active');
          $('label[for="courier_euroshipment"]').addClass('active');
        }
        else{
          $('label[for="courier_speedy"]').removeClass('active');
          $('label[for="courier_econt"]').addClass('active');
          $('label[for="courier_euroshipment"]').removeClass('active');
        }

        $("#city").autocomplete('option', 'source', "/"+country+"/get-cities?courier=" + $('.courier-box input[name=courier]:checked').val());


        $('#city').val('');
        $('#city_id').val('');
        $('#office').val('');
        $('#office_id').val('');
      });
      // $('input[name=courier]:first').prop('checked', true);
      $("#city").autocomplete({
        source: "/"+country+"/get-cities?courier=" + $('input[name=courier]:checked').val(),
        focus: function() {
          return false;
        },
        select: function (event, suggestion) {
          var name = suggestion.item.value;
          var value_input = suggestion.item.city;
          var city_id = suggestion.item.city_id;
          var zip = suggestion.item.zip;

          setTimeout(function(){
            $('#city').val(value_input);
            $('#city_id').val(city_id);
            $('#zip').val(zip);
            if (country == 'bg') {
              console.log($('#city').val());
              $("#address").autocomplete('option', 'source', "/"+country+'/'+city_id+"/get-addresses");
              $("#office").autocomplete('option', 'source', "/"+country+'/'+city_id+"/get-offices?courier="  + $('input[name=courier]:checked').val());

              var data_office = {
                _token: csrf,
                city_id: city_id
              }
            }
          },150);

        }
      });
    }else{
      $("#city").autocomplete({
        source: "/"+country+"/get-cities?courier=5",
        focus: function() {
          return false;
        },
        select: function (event, suggestion) {
          var name = suggestion.item.value;
          var value_input = suggestion.item.city;
          var city_id = suggestion.item.city_id;
          var zip = suggestion.item.zip;

          setTimeout(function(){
            $('#city').val(value_input);
            $('#city_id').val(city_id);
            $('#zip').val(zip);
            if (country == 'bg') {
              $("#address").autocomplete('option', 'source', "/"+country+'/'+city_id+"/get-addresses");
              $("#office").autocomplete('option', 'source', "/"+country+'/'+city_id+"/get-offices");

              var data_office = {
                _token: csrf,
                city_id: city_id
              }
            }
          },150);

        }
      });
    }


        $("#address").autocomplete({
          source: "/"+country+'/'+$('#city_id').val()+"/get-addresses",
          focus: function() {
            // prevent value inserted on focus
            return false;
          },
          select: function (event, suggestion) {
            var name = suggestion.item.label;
            var address_id = suggestion.item.id;

            $('#address_id').val(address_id);
          }
        });



        $("#office").autocomplete({
          source: "/"+country+'/'+$('#city_id').val()+"/get-offices",
          focus: function() {
            // prevent value inserted on focus
            return false;
          },
          minLength: 0,
          select: function (event, suggestion) {
            var name = suggestion.item.label;
            var office_id = suggestion.item.id;


            $('#office_id').val(office_id);
          }
        });
        $("#office").on('click', function(){
          $(this).autocomplete("search", $(this).val());
        })

        // $('#office_select').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
        //   var office = $('#office_select option:selected').text();
        //   $('#office').val(office);
        // });



      $('#select-address').on('change', function(){
          var value = $('#select-address option:selected').val();
          var data = {
            id: value,
            _token: csrf
          }

          $('#city_id').val('');
          $('#zip').val('');
          $('#address').val('');
          $('#address_id').val('');
          $('#no').val('');
          $('#block').val('');
          $('#entrance').val('');
          $('#floor').val('');
          $('#apartment_no').val('');
          $('#office_select').html('');
          $('#office').val('');
          // $('#office_select').selectpicker('refresh');

          $.ajax({
            url: '/'+country+'/select-address',
            data: data,
            type: 'post',
            dataType: 'json',
            success: function(data){
              if (data.shipping_to == 1) {
                $('#shipping_to_office').prop('checked', false);
                $('#shipping_to_address').prop('checked', true).trigger('change');
                $('#city').val(data.city);
                // $('#city_id').val(data.city_id);
                $('#zip').val(data.zip);
                $('#address').val(data.address);
                // $('#address_id').val(data.address_id);
                $('#no').val(data.no);
                $('#block').val(data.block);
                $('#entrance').val(data.entrance);
                $('#floor').val(data.floor);
                $('#apartment_no').val(data.apartment_no);
              }else{
                $('#shipping_to_address').prop('checked', false);
                $('#shipping_to_office').prop('checked', true).trigger('change');
                $('#city').val(data.city);
                $('#office').val(data.office);
                // $('#city_id').val(data.city_id);
                $('#zip').val(data.zip);
                // var office_id = data.office_id;
                // var type = data.type;

                // setTimeout(function(){
                //   var data_office = {
                //     _token: csrf,
                //     city_id: data.city_id
                //   }
                //   $.ajax({
                //     url: "/"+country+"/get-offices",
                //     dataType: 'json',
                //     type: 'post',
                //     data: data_office,
                //     success: function(data){
                //       $('#office_select').html('');
                //       $.each(data, function(key, value){
                //
                //         const option = `<option value="${value.id}|${value.type}">${value.label} - ${value.type}</option>`;
                //
                //         $('#office_select').append(option);
                //       });
                //
                //
                //       $('#office_select').selectpicker('refresh');
                //       $('#office_select').selectpicker('val', office_id+"|"+type);
                //     }
                //   });
                // }, 300)
              }
            }
          })
      });


      $(document).on('click', '.btn-number', function(e){
        e.preventDefault();

        fieldName = $(this).attr('data-field');
        type      = $(this).attr('data-type');
        url      = $(this).attr('data-url');
        var input = $("input[name='"+fieldName+"']");
        var currentVal = parseInt(input.val());
        var payment = $("input[name=payment]:checked").val();
        var leasing_payment = $('input[name=leasing_payment]:checked').val();
        console.log(leasing_payment);
        if (!isNaN(currentVal)) {
          if(type == 'minus') {
            if(currentVal > input.attr('min')) {
              input.val(currentVal - 1).change();
              $('.loader').removeClass('d-none');

              var data = {
                _token: csrf,
                payment: payment,
                leasing_payment: leasing_payment
              }
              $.ajax({
                url: url,
                data: data,
                type: 'post',
                dataType: 'json',
                success: function(data){
                  $('.checkout-products-box').html(data.checkout_products);
                  // initScrollbar();
                  $('.loader').addClass('d-none');
                }
              })

            }
            if(parseInt(input.val()) == input.attr('min')) {
              $(this).attr('disabled', true);
            }

          } else if(type == 'plus') {

            if(currentVal < input.attr('max')) {
              input.val(currentVal + 1).change();
              $('.loader').removeClass('d-none');
              var data = {
                _token: csrf,
                payment: payment,
                leasing_payment: leasing_payment
              }
              $.ajax({
                url: url,
                data: data,
                type: 'post',
                dataType: 'json',
                success: function(data){
                  $('.checkout-products-box').html(data.checkout_products);
                  // initScrollbar();
                  $('.loader').addClass('d-none');
                }
              })
            }
            if(parseInt(input.val()) == input.attr('max')) {
              $(this).attr('disabled', true);
            }

          }

        } else {
          input.val(0);
        }

        setTimeout(function(){
          cardPaymentDiscount();
          showLeasingTotals();
          // location.reload();
        }, 800)
      });

      $('.input-number').focusin(function(){
        $(this).data('oldValue', $(this).val());
      });

      // $('.input-number').change(function() {
      //   minValue =  parseInt($(this).attr('min'));
      //   maxValue =  parseInt($(this).attr('max'));
      //   valueCurrent = parseInt($(this).val());
      //
      //   name = $(this).attr('name');
      //   if(valueCurrent >= minValue) {
      //     $(".btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
      //   } else {
      //     alert('Sorry, the minimum value was reached');
      //     $(this).val($(this).data('oldValue'));
      //   }
      //   if(valueCurrent <= maxValue) {
      //     $(".btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
      //   } else {
      //     alert('Sorry, the maximum value was reached');
      //     $(this).val($(this).data('oldValue'));
      //   }
      //
      //
      // });
      $(".input-number").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
          // let it happen, don't do anything
          return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
        }
      });
    // ======== Radio button change actions ========
    if (checkIfExists('.checkout input[name=invoice]')) {
      $('.checkout input[name=invoice]').change(function () {
        if($('.checkout input[name=invoice]:checked').val() == 1) {
          $('.invoice-form-wrapper').slideDown('fast')
          $('.invoice-form-wrapper input').removeClass('ignore');
        }else{
          $('.invoice-form-wrapper').slideUp('fast')
          $('.invoice-form-wrapper input').addClass('ignore');
        }
      })
    }


    if (country == 'bg') {
        changeShippingTo();
   
    // if(checkIfExists('.test-checkout')){
    //     changeShippingTo();
      

    // }else{
    //        if ($('.shipping-info-box input[name=shipping_to]:checked').val() == 2) {
    //     // Офис
    //     $('.delivery-address input#address').slideUp('fast').addClass('ignore');
    //     $('.delivery-address input#no').slideUp('fast').addClass('ignore');
    //     $('#address-label').addClass('d-none');
    //     $('#address-no-label').addClass('d-none');
    //     $('#office-label').removeClass('d-none');
    //     $('#office').removeClass('d-none').removeClass('ignore');

    //     $('.delivery-address .dropdown.bootstrap-select').slideDown('fast');
    //     $('#office_select').removeClass('ignore');
    //     $('#block-info').addClass('d-none');
    //     $('#address-error').html('');
    //     $('.office-address-wrapper').removeClass('d-none');
    //     $('.street-address-wrapper').addClass('d-none');
    //     $('.delivery-address').removeClass('d-none');
    //     // Cookies.set('shipping_to', '1', {expires: inFifteenMinutes, 'samesite': 'strict'});
    //     // Куриер - до офис  - може ЕКОНТ и СПИДИ
    //       $('.courier-box .radio-econt').prop('disabled', false);
    //       $('.courier-box label[for=courier_econt]').removeClass('disabled');
    //   } else if ($('.shipping-info-box input[name=shipping_to]:checked').val() == 1) {
    //     // Адрес
    //     $('.delivery-address input#address').slideDown('fast').removeClass('ignore');
    //     $('.delivery-address input#no').slideDown('fast').removeClass('ignore');
    //     $('#address-label').removeClass('d-none');
    //     $('#address-no-label').removeClass('d-none');
    //     $('#office-label').addClass('d-none');
    //     $('#office').addClass('d-none').addClass('ignore');

    //     $('.delivery-address .dropdown.bootstrap-select').slideUp('fast');
    //     $('#office_select').addClass('ignore');
    //     $('#block-info').removeClass('d-none');
    //     $('#office-error').html('');
    //     $('.office-address-wrapper').addClass('d-none');
    //     $('.street-address-wrapper').removeClass('d-none');
    //     $('.delivery-address').removeClass('d-none');
    //     // Cookies.set('shipping_to', '0', {expires: inFifteenMinutes, 'samesite': 'strict'});

    //     // Куриер - до адрес  - може само ЕКОНТ
    //       $('.courier-box .radio-speedy').prop('checked', true);
    //       $('.courier-box label[for=courier_speedy]').addClass('active');
    //       $('.courier-box .radio-econt').prop('disabled', true);
    //       $('.courier-box label[for=courier_econt]').addClass('disabled').removeClass('active');

    //   }else{
    //     $('.delivery-address').toggleClass('d-none');
    //   }
    // }
    }

    $('.shipping-info-box input[name=shipping_to], .shipping-info-box select[name=shipping_to]').change(function () {

      if (country == 'bg') {
        changeShippingTo();
          $("#city").autocomplete('option', 'source', "/"+country+"/get-cities?courier=" + $('.courier-box input[name=courier]:checked').val());
        // if(checkIfExists('.test-checkout')){
        

        // }else{

        //        if ($(this).val() == 2) {
        //   // Офис
        //   $('.delivery-address input#address').slideUp('fast').addClass('ignore');
        //   $('.delivery-address input#no').slideUp('fast').addClass('ignore');
        //   $('#address-label').addClass('d-none');
        //   $('#address-no-label').addClass('d-none');
        //   $('#office-label').removeClass('d-none');
        //   $('#office').removeClass('d-none').removeClass('ignore');

        //   $('.delivery-address .dropdown.bootstrap-select').slideDown('fast');
        //   $('#office_select').removeClass('ignore');
        //   $('#block-info').addClass('d-none');
        //   $('#address-error').html('');
        //   $('.office-address-wrapper').removeClass('d-none');
        //   $('.street-address-wrapper').addClass('d-none');
        //   $('.delivery-address').removeClass('d-none');
        //   // Cookies.set('shipping_to', '1', {expires: inFifteenMinutes, 'samesite': 'strict'});

        //   $('label[for="shipping_to_address"]').removeClass('active');
        //   $('label[for="shipping_to_office"]').addClass('active');

        //   // Куриер - до офис  - може ЕКОНТ и СПИДИ
        //   $('.courier-box .radio-econt').prop('disabled', false);
        //   $('.courier-box label[for=courier_econt]').removeClass('disabled');
        // } else if ($(this).val() == 1) {
        //   // Адрес
        //   $('.delivery-address input#address').slideDown('fast').removeClass('ignore');
        //   $('.delivery-address input#no').slideDown('fast').removeClass('ignore');
        //   $('#address-label').removeClass('d-none');
        //   $('#address-no-label').removeClass('d-none');
        //   $('#office-label').addClass('d-none');
        //   $('#office').addClass('d-none').addClass('ignore');

        //   $('.delivery-address .dropdown.bootstrap-select').slideUp('fast');
        //   $('#office_select').addClass('ignore');
        //   $('#block-info').removeClass('d-none');
        //   $('#office-error').html('');
        //   $('.office-address-wrapper').addClass('d-none');
        //   $('.street-address-wrapper').removeClass('d-none');
        //   $('.delivery-address').removeClass('d-none');
        //   $('label[for="shipping_to_address"]').addClass('active');
        //   $('label[for="shipping_to_office"]').removeClass('active');
        //   // Cookies.set('shipping_to', '0', {expires: inFifteenMinutes, 'samesite': 'strict'});

        //   // Куриер - до адрес  - може само ЕКОНТ
        //   $('.courier-box .radio-speedy').prop('checked', true);
        //   $('.courier-box label[for=courier_speedy]').addClass('active');
        //   $('.courier-box .radio-econt').prop('disabled', true);
        //   $('.courier-box label[for=courier_econt]').addClass('disabled').removeClass('active');
        // }else{
        //   $('.delivery-address').toggleClass('d-none');
        // }

        // }
     
      }

    })

    if (checkIfExists('.checkout input[name=payment]')) {
      $('input[name=payment]').on('change', function(){
        let val = $('.checkout input[name=payment]:checked').val();

        $('.payment-label').removeClass('active');
        $(`label[for="payment_${val}"]`).addClass('active');

        checkoutLeasingTable();
        showLeasingTotals();

      })
    }

    if(checkIfExists('.checkout-leasing')){
        $('.checkout-leasing table tbody tr').on('click', function(){
          $('.checkout-leasing table tr').removeClass('leasingrow');
          $(this).addClass('leasingrow');
          $(this).find('input[name=leasing_payment]').prop('checked', true);
          showLeasingTotals();
      });
    }




    setTimeout(function(){
        if ($('.shipping-info-box input[name=shipping_to]:checked') == 2 || Cookies.get('shipping_to') == 2) {
      $('.shipping-info-box input[name=shipping_to][value=1]').prop('checked', false);
      $('.shipping-info-box input[name=shipping_to][value=2]').prop('checked', true);
      $('.delivery-address input#address').slideUp('fast').addClass('ignore');
      $('.delivery-address .dropdown.bootstrap-select').slideDown('fast');
      $('#office').removeClass('ignore');
      $('label[for="shipping_to_address"]').removeClass('active');
      $('label[for="shipping_to_office"]').addClass('active');
    } else {
      $('.shipping-info-box input[name=shipping_to][value=1]').prop('checked', true);
      $('.shipping-info-box input[name=shipping_to][value=2]').prop('checked', false);
      $('.delivery-address input#address').slideDown('fast').removeClass('ignore');
      $('.delivery-address .dropdown.bootstrap-select').slideUp('fast');
      $('#office').addClass('ignore');
      $('label[for="shipping_to_address"]').addClass('active');
      $('label[for="shipping_to_office"]').removeClass('active');
    }
    }, 1500);
    // ======== Radio button change actions ======== //


    // $('.qty-wrapper a').click(function (e) {
      //   updateProductQuantity(e)
      // })


    }

    })
